import {IData} from "@Types/IData";
import {ResponseType} from "axios";

export const RESPONSE_TYPE_BLOB: ResponseType = 'blob'
export const AXIOS_RESPONSE_TYPE_BLOB: IData = {
  responseType: RESPONSE_TYPE_BLOB,
};


export const  SSO_PROFILE = 'sso-profile';

export const RESPONSE_TYPE_STREAM: ResponseType = 'stream'
export const AXIOS_RESPONSE_TYPE_STREAM: IData = {
  responseType: RESPONSE_TYPE_STREAM,
};

export const CREATE: string = 'create';
export const EDIT: string = 'edit';

export const VIEW: string = 'view';

export const YES: string = 'yes';
export const NO: string = 'no';

export const DEVICE_TYPE_SATELLITE: string = 'satellite';
export const DEVICE_TYPE_ROADMAP: string = 'roadmap';
export const DEVICE_TYPE_STANDARD: string = 'standard';
export const DEVICE_TYPE_SILVER: string = 'silver';
export const DEVICE_TYPE_RETRO: string = 'retro';
export const DEVICE_TYPE_DARK: string = 'dark';
export const DEVICE_TYPE_NIGHT: string = 'night';
export const DEVICE_TYPE_AUBERGINE: string = 'aubergine';
export const ROUTE_STATUS_PENDING: string = 'pending';
export const ROUTE_STATUS_APPROVED: string = 'approved';
export const ROUTE_STATUS_STARTED: string = 'started';
export const ROUTE_STATUS_PAUSED: string = 'paused';

//Route Meta Column returns from backend
export const ROUTE_META_LOW_RISK: string = 'low_risk';
export const ROUTE_META_APPROVED: string = 'approved';
export const ROUTE_META_HIGH_RISK: string = 'high_risk';
export const MODULE_HIGH_RISK_APPROVALS: string = 'enable_high_risk_approvals';
export const MODULE_RISK_ASSESSMENT: string = 'enable_risk_assessment';
export const MODULE_REFERENCE_DOX: string = 'enable_reference_docs';
export const ROUTE_META_ROUTE_WARNINGS: string = 'route_plan_warnings';

export const MODULE_EMERGENCY_HAZARDS: string = 'enable_emergency_hazards';

export const MODULE_ON_TRIP_START: string = 'enable_on_trip_start';
export const MODULE_ON_CHECKIN_POINT: string = 'enable_on_check_in_point';
export const MODULE_ON_TRIP_COMPLETE: string = 'enable_on_trip_complete';
export const MODULE_ROAD_SPEEDING : string= 'enable_road_speeds';
export const MODULE_ON_JOURNEY_NOTIFICATION: string = 'enable_journey_notification';
export const MODULE_PIVOTEL_TRACKING: string = 'enable_pivotel_tracking';
export const MODULE_AUTO_APPROVE_TRIP: string = 'enable_auto_approve_trip';

export const MODULE_NEXTRAQ_TRACKING: string = 'enable_nextraq_tracking';
export const MODULE_MIXTELEMATICS_TRACKING: string = 'enable_mixtelematics_tracking';
export const MODULE_NAVMAN_TRACKING: string = 'enable_navman_tracking';
export const MODULE_GARMIN_TRACKING: string = 'enable_garmin_tracking';
export const MODULE_SUBMIT_SELECT_APPROVER: string = 'enable_submit_select_approver';

export const MODULE_GEOTAB_TRACKING: string = 'enable_securatrak_tracking';
export const MODULE_ONE_OFF_JOURNEY: string = 'enable_one_off_journey';
export const MODULE_ROSTERING: string = 'enable_rostering';
export const MODULE_4_WHEEL_CHECKING: string = 'enable_4_wheel_cert_checking';
export const MODULE_PERSONAL_TRIP: string = 'enable_personal_trip';
export const MODULE_LONE_WORKER: string = 'enable_lone_worker';
export const MODULE_TRAVEL_DOCUMENTS: string = 'enable_travel_documents';
export const MODULE_EMPLOYEE_INDUCTION: string = 'enable_employee_induction';
export const MODULE_CHECKIN_PERSON_SELECTION = 'enable_checkin_person_selection'
export const MODULE_SYSTEM_MESSAGE_BROADCAST = 'enable_message_broadcast_setup'
export const MODULE_TRAVEL_MODE_SELECTION: string = 'enable_transport_mode_selection';
export const MODULE_PASSENGER_CONFIRMATION: string = 'enable_passenger_confirmation';
export const MODULE_FLIGHT_ACCOMMODATION: string = 'enable_flight_accommodation';
export const MODULE_HOSTS_ON_CHECKIN: string = 'enable_hosts_on_checkin';
export const MODULE_SEQUENCE_NUMBER: string = 'enable_sequence_number';
export const MODULE_PRE_TRIP_CHECKLIST = 'enable_pre_post_checklist';
export const MODULE_ENABLE_ADDITIONAL_APPROVAL_PROCESS = 'enable_additional_approval_process';
export const MODULE_EXECUTIVE_APPROVALS = 'enable_executive_approvals';
export const MODULE_JMS_DOCUMENTS = 'enable_jms_documents';
export const MODULE_ENABLE_APPROVAL_PROCESS = 'enable_approval_process';
export const MODULE_ENABLE_GROUP_LEVEL_EMERGENCY = 'enable_group_level_emergency';
export const MODULE_ENABLE_GENETEC = 'enable_genetec';
export const MODULE_MANDATORY_DUAL_APPROVAL = 'enable_mandatory_dual_approval';


// FormTemplatePage
export const SECTION_TITLE = 'section_title';

export const TEXT = 'text';

export const PARAGRAPH = 'paragraph';

export const CHECKBOXES = 'checkboxes';

export const RADIO = 'radio';

export const DROP_DOWN = 'dropdown';

export const READ_ONLY_TEXT = 'read_only_text';

export const APP_PAGE_BREAK = 'app_page_break';

export const ROUTE_PLAN = 'route_plan';

export const DATE_TIME = 'date_time';
export const DATE = 'date';

export const PHOTO_CAPTURE = 'photo_capture';

export const LONE_REMOTE_WORKER_OVERDUE: string = 'overdue';

export const ClientUserApiCredentials = "client_user_api_credentials";
export const PivotelApiCredentials = "pivotel_api_credentials";
export const NavmanApiCredentials = "navman_api_credentials";
export const NextraqApiCredentials = "nextraq_api_credentials";
export const MixTelematicsApiCredentials = "mixtelematics_api_credentials";
export const GeotabApiCredentials = "geotab_api_credentials";
export const GarminApiCredentials = "garmin_api_credentials";

export const MAP_ZOOM_THRESHOLD = 16;

export const MARKER = 'marker';
export const POI = 'poi';

export const GEOFENCES = 'geoFences';
export const HAZARDZONES =  'hazardZones'
export const FATIGUE =  'fatigue'

export const LONE_WORKER = 'Lone Worker';

export const REMOTE_WORKER = 'Remote Worker';

export const GEOFENCE = 'geofence';

export const WITHIN = 'within';
export const GEOTAB: string = 'securatrak';


export const GOOGLEMAP: string = 'google';
export const TRIMBLEMAP: string = 'trimble';


export const DRIVING = 'DRIVING';

export const FAHRENHEIT = 'F';

/** @var string Celsius temperature unit constant */
export const CELSIUS = 'C';

export const KM = 'km';
export const MILES = 'miles';

